module.exports = __webpack_public_path__ + "img/twitter-solid.5f3ba7be.svg";